export const validateEmail = (email: string) => {
  if (email.length === 0) {
    return true;
  }
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const validatePassword = (password: string) => {
  const minLength = password.length >= 1;

  return minLength && true;
};

export const validateUrl = (url: string) => {
  if (url.length === 0) {
    return true;
  }
  const re = /^(http|https):\/\/[^ "]+$/;
  return re.test(url);
};
